import { render, staticRenderFns } from "./CopyModal.vue?vue&type=template&id=a5937466&scoped=true"
import script from "./CopyModal.vue?vue&type=script&lang=js"
export * from "./CopyModal.vue?vue&type=script&lang=js"
import style0 from "./CopyModal.vue?vue&type=style&index=0&id=a5937466&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5937466",
  null
  
)

export default component.exports